<div class="modal-content">
    <div class="modal-header">
        <h4 class="modal-title">Anmeldedaten erforderlich</h4>
        <button class="btn btn-outline-secondary" type="button" title="Schließen" aria-label="Close" (click)="modalService.dismissAll()">
          <img src="assets/icons/close.svg" alt="Schließen" width="16" height="16" style="margin-bottom: 4px">
        </button>
    </div>
    <div class="modal-body">
        <p>
            Bitte geben Sie Ihre Anmeldedaten ein um Ihre Session zu verlängern:
        </p>
        <div class="form-group">
            <label for="labelUser">Benutzername</label>
            <input class="form-control" id="labelUser" type="text" [(ngModel)]=credentials.username>
        </div>
        <div class="form-group">
            <label for="labelPwd">Passwort</label>
            <input class="form-control" id="labelPwd" type="password" [(ngModel)]=credentials.password>
        </div>
        <div class="form-group form-check">
            <input type="checkbox" class="form-check-input" id="checkbox-save-login-data" [(ngModel)]="saveData">
            <label class="form-check-label" for="checkbox-save-login-data">
                Anmeldedaten speichern
            </label>
        </div>
        <!-- Message box for the user if something goes wrong-->
        <ngb-alert *ngIf="message" [dismissible]="false" type="danger">
            {{message}}
        </ngb-alert>
    </div>

    <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Abbrechen</button>
        <button type="button" class="btn btn-primary" (click)="extend()">Verlängern</button>
    </div>
</div>
